import { getDesktopBridge } from './desktopBridge'

const NO_BRIDGE = Promise.resolve(null)

function safeBridgeCall(namespace, method, payload, fallback = null) {
  const bridge = getDesktopBridge()
  if (!bridge?.[namespace]?.[method]) {
    return Promise.resolve(fallback)
  }
  return bridge[namespace][method](payload)
}

export const ideApi = {
  validateToken() {
    return safeBridgeCall('ide', 'validateToken')
  },
  startSession(payload = {}) {
    return safeBridgeCall('ide', 'startSession', payload)
  },
  endSession(payload) {
    return safeBridgeCall('ide', 'endSession', payload)
  },
  getCurrentSession() {
    return safeBridgeCall('ide', 'getCurrentSession')
  },
  getUsage() {
    return safeBridgeCall('ide', 'getUsage')
  },
  getProviderHealth() {
    return safeBridgeCall('ide', 'getProviderHealth')
  },
  createProject(payload) {
    return safeBridgeCall('ide', 'createProject', payload)
  },
  generateAi(payload) {
    return safeBridgeCall('ide', 'generateAi', payload)
  },
}

export const runtimeApi = {
  getCurrent() {
    return safeBridgeCall('runtime', 'getCurrent')
  },
  heartbeat() {
    return safeBridgeCall('runtime', 'heartbeat')
  },
  terminate() {
    return safeBridgeCall('runtime', 'terminate')
  },
  startRunner(profile) {
    return safeBridgeCall('runtime', 'startRunner', { profile })
  },
  getRunner(runId, jobId) {
    return safeBridgeCall('runtime', 'getRunner', { runId, jobId })
  },
  cancelRunner(runId, jobId) {
    return safeBridgeCall('runtime', 'cancelRunner', { runId, jobId })
  },
}

export const workspaceApi = {
  openProjectDirectory() {
    return safeBridgeCall('workspace', 'openProjectDirectory')
  },
  createProjectDirectory(payload) {
    return safeBridgeCall('workspace', 'createProjectDirectory', payload)
  },
  readFile(payload) {
    return safeBridgeCall('workspace', 'readFile', payload)
  },
  saveFile(payload) {
    return safeBridgeCall('workspace', 'saveFile', payload)
  },
}

export const terminalApi = {
  runCommand(payload) {
    return safeBridgeCall('terminal', 'runCommand', payload)
  },
  create(payload) {
    return safeBridgeCall('terminal', 'create', payload)
  },
  write(payload) {
    return safeBridgeCall('terminal', 'write', payload)
  },
  resize(payload) {
    return safeBridgeCall('terminal', 'resize', payload)
  },
  dispose(payload) {
    return safeBridgeCall('terminal', 'dispose', payload)
  },
  onData(terminalId, callback) {
    const bridge = getDesktopBridge()
    if (!bridge?.terminal?.onData) return () => {}
    return bridge.terminal.onData(terminalId, callback)
  },
  onExit(terminalId, callback) {
    const bridge = getDesktopBridge()
    if (!bridge?.terminal?.onExit) return () => {}
    return bridge.terminal.onExit(terminalId, callback)
  },
}
